import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { GC_USER_ID, PROJECT_TRACKER_ID } from '@/constants'
import { trackersQuery } from '@/graphql/queries/tracker'
import { currentBookPref } from '@/graphql/queries/bookPref'
import { addToTrackersOnGroup } from '@/graphql/mutations/group'
import TrackerEditModal from '../modals/TrackerEdit'
import EventEditModal from '../modals/EventEdit'

import * as moment from 'moment'
import {
  Modal,
  Typography,
  Paper,
  GridList,
  GridListTile,
  Checkbox
} from 'material-ui'
import { FormGroup, FormControlLabel } from 'material-ui/Form'
import List, { ListItem, ListItemText } from 'material-ui/List'
import EditIcon from 'material-ui-icons/Edit'
import Loading from './Loading'

@graphql(currentBookPref, {
  name: 'currentBookPref',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      isCurrent: true
    }
  })
})
@graphql(trackersQuery, {
  name: 'trackersQuery',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      isPublic: true,
      isAdmind: true
    }
  })
})
@graphql(addToTrackersOnGroup, {
  name: 'addToTrackersOnGroup',
  options: {
    refetchQueries: ['groupQuery']
  }
})
export default class TrackersModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenTracker: false,
      OpenAdd: false,
      OpenTimer: false,

      trackerCategory: 'Very Productive',
      event: '',
      action: '',
      tracker: '',
      trackers: '',
      plan: false,

      loading: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
    if (nextProps.trackers !== this.props.trackers) {
      if (nextProps.trackers && nextProps.trackers.length > 0) {
        var g = []
        nextProps.trackers.forEach(e => g.push(e.id))
        this.setState({ trackers: g })
      }
    }
  }
  handleClose = () => {
    this.props.onClose()
    this.setState({
      plan: false,
      open: false
    })
  }

  handlePlan = () => {
    this.setState({ plan: !this.state.plan })
  }

  handleSessionAdd = (type, trackerId, trackerName) => {
    this.setState({ event: '' })
    var sE = this.state.plan
      ? moment(new Date(this.props.date))
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
      : this.props.start
    var eE = this.state.plan
      ? moment(new Date(this.props.date))
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
          .add(1, 'hour')
      : moment(new Date(this.props.date))
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
    var mins = 0
    if (sE.isSameOrBefore(eE)) {
      mins = eE.diff(sE, 'minutes')
    } else {
      mins = 0
    }
    switch (type) {
      case 'energy':
        var newEventEnergy = {
          startedAt: moment(new Date(this.props.date))
            .hour(moment().hour())
            .minute('0')
            .second('0'),
          dataOrigin: this.props.origin,
          eventType: this.state.plan ? 'plan' : 'happened',
          options: {
            value: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName
          },
          mood: 0,
          comment: ''
        }

        this.setState({ event: newEventEnergy })
        break
      case 'checked':
      case 'bodyweight':
        var newEventValue = {
          startedAt: moment(new Date(this.props.date))
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second()),
          dataOrigin: this.props.origin,
          eventType: this.state.plan ? 'plan' : 'happened',
          options: {
            value: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName
          },
          mood: 0,
          comment: ''
        }

        this.setState({ event: newEventValue })
        break
      case 'reading':
        var bookId = ''
        var bookName = ''
        var bookAuthor = ''
        var bookPrefId = ''
        var bookPrefMaxPage = ''
        var bookPrefPercent = ''
        var bookTotalPages = ''
        var pageStart = ''
        if (
          this.props.currentBookPref.allBookPrefs &&
          this.props.currentBookPref.allBookPrefs.length === 1
        ) {
          bookId = this.props.currentBookPref.allBookPrefs[0].book.id
          bookName = this.props.currentBookPref.allBookPrefs[0].book.name
          bookAuthor = this.props.currentBookPref.allBookPrefs[0].book.author
          bookTotalPages = this.props.currentBookPref.allBookPrefs[0].book
            .totalPages
          bookPrefId = this.props.currentBookPref.allBookPrefs[0].id
          bookPrefMaxPage = this.props.currentBookPref.allBookPrefs[0].maxPage
          bookPrefPercent = this.props.currentBookPref.allBookPrefs[0]
            .percentRead
          if (this.props.currentBookPref.allBookPrefs[0].maxPage > 0) {
            pageStart = this.props.currentBookPref.allBookPrefs[0].maxPage
          }
        }
        var newReading = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: this.props.origin,
          eventType: this.state.plan ? 'plan' : 'happened',
          minutes: mins,
          options: {
            value: '',
            pageStart: pageStart,
            pageEnd: ''
          },
          book: {
            id: bookId,
            name: bookName,
            author: bookAuthor,
            totalPages: bookTotalPages
          },
          bookPref: {
            id: bookPrefId,
            maxPage: bookPrefMaxPage,
            percentRead: bookPrefPercent
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }

        this.setState({ event: newReading })
        break
      case 'project':
        global.localStorage.setItem(PROJECT_TRACKER_ID, trackerId)
        var newProject = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: this.props.origin,
          eventType: this.state.plan ? 'plan' : 'happened',
          minutes: mins,
          task: {
            id: '',
            name: ''
          },
          subtask: {
            id: '',
            name: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }

        this.setState({ event: newProject })
        break
      case 'sleep':
        var newSleep = {
          startedAt:
            moment(new Date(this.props.date)).format('l') ===
            moment().format('l')
              ? moment(new Date(this.props.date))
                  .hour(moment().hour())
                  .minute(moment().minute())
                  .second(moment().second())
                  .subtract(8, 'hours')
              : moment(new Date(this.props.date))
                  .hour('7')
                  .minute('0')
                  .second('0')
                  .subtract(8, 'hours'),
          completedAt:
            moment(new Date(this.props.date)).format('l') ===
            moment().format('l')
              ? moment(new Date(this.props.date))
                  .hour(moment().hour())
                  .minute(moment().minute())
                  .second(moment().second())
              : moment(new Date(this.props.date))
                  .hour('7')
                  .minute('0')
                  .second('0'),
          dataOrigin: this.props.origin,
          eventType: this.state.plan ? 'plan' : 'happened',
          minutes: 480,
          options: {
            value: '',
            isNap: false,
            brianClearness: 'Normal'
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }
        this.setState({ event: newSleep })
        break

      default:
        var newEventDefault = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: this.props.origin,
          eventType: this.state.plan ? 'plan' : 'happened',
          minutes: mins,
          options: {
            value: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }
        this.setState({ event: newEventDefault })
        break
    }
    if (this.props.origin === 'manualAdd') {
      this.setState({
        OpenAdd: true,
        plan: false
      })
    } else if (this.props.origin === 'alchmeyTimer') {
      this.setState({
        OpenTimer: true,
        plan: false
      })
    }
  }

  handleAddTo = id => {
    this.setState({ loading: true })
    this.props
      .addToTrackersOnGroup({
        variables: {
          groupsGroupId: this.props.id,
          trackersTrackerId: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          open: false,
          loading: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          open: false,
          loading: false
        })
      })
  }

  handleSelect = (type, trackerId, trackerName) => {
    if (this.props.origin === 'group') {
      this.handleAddTo(trackerId)
    } else {
      this.props.onClose()
      this.setState({
        open: false
      })
      this.handleSessionAdd(type, trackerId, trackerName)
    }
  }

  handleTrackerEdit = (action, tracker, category) => {
    this.setState({
      action: action
    })
    if (action === 'add') {
      var newTracker = {
        category: category,
        color:
          category === 'Very Productive'
            ? 'rgba(147, 112, 219,0.6)'
            : category === 'Productive'
              ? 'rgba(100,149,237,0.3)'
              : category === 'Maintenance'
                ? 'rgba(128,128,128,0.4)'
                : category === 'Distracting'
                  ? 'rgba(255,105,180,0.6)'
                  : category === 'Very Distracting'
                    ? 'rgba(255,0,0,0.4)'
                    : 'rgba(128,128,128,0.4)',
        isDuration: true,
        isPublic: false,
        isStared: false,
        name: '',
        type: ''
      }
      this.setState({ tracker: newTracker })
    } else if (action === 'edit') {
      this.setState({ tracker: tracker })
    }
    this.setState({
      OpenTracker: true
    })
  }

  handleCloseTracker = () => {
    this.setState({
      OpenTracker: false
    })
  }

  handleCloseAdd = () => {
    this.setState({
      OpenAdd: false
    })
  }
  handleCloseTimer = () => {
    this.setState({
      OpenTimer: false
    })
  }

  handleTrackerCategoryChange = cat => {
    this.setState({ trackerCategory: cat })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday" style={{ borderRadius: 16 }}>
            {this.state.loading ? (
              <Loading />
            ) : this.props.trackersQuery.loading ? (
              <Loading />
            ) : this.props.currentBookPref.loading ? (
              <Loading />
            ) : (
              <div id="GetUpTime" className="divAddTpday">
                <List>
                  <ListItem divider>
                    <ListItemText
                      className="modalHealder"
                      primary={
                        <Typography
                          variant="body1"
                          style={{ fontSize: 18, color: 'grey' }}
                        >
                          Which tracker would you like?
                        </Typography>
                      }
                    />
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.plan}
                            onChange={this.handlePlan}
                            value="plan"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Plan"
                      />
                    </FormGroup>
                  </ListItem>
                  <ListItem>
                    <div className="divText">
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Very Productive')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Very Productive'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        +2
                      </Typography>
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Productive')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Productive'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        +1
                      </Typography>
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Maintenance')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Maintenance'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        0
                      </Typography>
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Distracting')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Distracting'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        -1
                      </Typography>
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Very Distracting')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Very Distracting'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        -2
                      </Typography>
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Personal')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Personal'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        Personal
                      </Typography>
                      <Typography
                        onClick={() =>
                          this.handleTrackerCategoryChange('Workout')
                        }
                        variant="caption"
                        className={
                          this.state.trackerCategory === 'Workout'
                            ? 'textFilter'
                            : 'textFilterGery'
                        }
                      >
                        Workout
                      </Typography>
                    </div>
                  </ListItem>
                </List>
                {
                  <GridList className="gridList" cols={4}>
                    {this.props.trackersQuery.allTrackers
                      .filter(
                        t =>
                          t.category === this.state.trackerCategory &&
                          !this.state.trackers.includes(t.id)
                      )
                      .map((t, index) => (
                        <GridListTile
                          xs={6}
                          cols={1}
                          key={t.id}
                          style={{ height: 108 }}
                        >
                          <Paper
                            className="paperBlock"
                            style={{ borderRadius: 36 }}
                          >
                            <div
                              onClick={() =>
                                this.handleSelect(t.type, t.id, t.name)
                              }
                              key={`bookblock-key-${index}`}
                              className="bookBlockChecked"
                              style={{
                                backgroundColor: t.color,
                                opacity: 0.55
                              }}
                            >
                              <img
                                alt=""
                                className="iconTracker"
                                src={process.env.PUBLIC_URL + '/cloud_done.png'}
                              />
                              <Typography
                                variant="caption"
                                style={{
                                  paddingLeft: 2,
                                  paddingRight: 2,
                                  textAlign: 'center',
                                  fontSize: 12,
                                  color: 'white',
                                  lineHeight: 1.1
                                }}
                              >
                                {t.name}
                              </Typography>
                            </div>
                            <div
                              onClick={() =>
                                this.handleTrackerEdit(
                                  'edit',
                                  t,
                                  this.state.trackerCategory
                                )
                              }
                              className="iconBtnEditSmallX"
                            >
                              <EditIcon
                                style={{
                                  color: 'lightgrey',
                                  fontSize: 14
                                }}
                              />
                            </div>
                          </Paper>
                        </GridListTile>
                      ))}

                    <GridListTile
                      xs={6}
                      cols={1}
                      key={'add'}
                      style={{ height: 90 }}
                    >
                      <Paper
                        className="paperBlock"
                        style={{ borderRadius: 36 }}
                        onClick={() =>
                          this.handleTrackerEdit(
                            'add',
                            '',
                            this.state.trackerCategory
                          )
                        }
                      >
                        <div
                          key={`bookblock-key-add`}
                          className="bookBlockChecked"
                          style={{ backgroundColor: 'white' }}
                        >
                          <img
                            alt=""
                            className="iconTracker"
                            src={process.env.PUBLIC_URL + '/cloud_done.png'}
                          />
                          <Typography
                            variant="body1"
                            id="bookName"
                            style={{
                              paddingLeft: 2,
                              paddingRight: 2,
                              textAlign: 'center',
                              fontSize: 12,
                              color: 'grey',
                              lineHeight: 1.1
                            }}
                          >
                            Add
                          </Typography>
                        </div>
                      </Paper>
                    </GridListTile>
                  </GridList>
                }
              </div>
            )}
          </Paper>
        </Modal>
        <TrackerEditModal
          open={this.state.OpenTracker}
          onClose={this.handleCloseTracker}
          tracker={this.state.tracker}
          action={this.state.action}
        />
        <EventEditModal
          open={this.state.OpenAdd}
          openTimer={this.state.OpenTimer}
          onClose={this.handleCloseAdd}
          onCloseTimer={this.handleCloseTimer}
          event={this.state.event}
          action={'add'}
          origin={this.props.origin}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/Trackers.js